import {PlayType} from './playType';

export const PlayTypeGroups: Record<string, PlayType[]> = {
  O: [PlayType.Pass, PlayType.Run, PlayType['2Pt'], PlayType.TeamLost],
  D: [PlayType.Pass, PlayType.Run, PlayType['2PtDefend'], PlayType.TeamLost],
  K: [PlayType.Punt, PlayType.PuntRec, PlayType.KO, PlayType.KOREC,
      PlayType.ExtraPt, PlayType.ExtraPtBlock, PlayType.TeamLost, PlayType.FakeFG,
      PlayType.FakePunt, PlayType.OnsideKick, PlayType.OnsideKickRec
  ],
  X: [PlayType.Missing],
};
